import { ViewportPlugin } from '@jollywise/jollygoodgame/src/components/viewport/ViewportPlugin';

export class ViewportPluginSesame extends ViewportPlugin {
  constructor(...args) {
    super(...args);
    window.addEventListener('orientationchange', this._handleOrientationChange.bind(this));
    window.addEventListener('resize', this._handleWindowResized.bind(this));
    this._handleOrientationChange();
  }

  _handleOrientationChange() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(this._handleWindowResized.bind(this), 20);
  }

  _handleWindowResized() {
    if (window.innerWidth / window.innerHeight < 1.33) {
      const targetHeight = this.game.scale.parentSize.width * 0.75;
      this.game.scale.setParentSize(this.game.scale.parentSize.width, targetHeight);
    }
  }

  updateViewport() {
    console.log('UPDATE VIEWPORT');
    super.updateViewport();

    if (window.innerWidth / window.innerHeight < 1.33) {
      const windowAspect = 4 / 3;
      const height = this.game.defaultDimensions.height;
      const width = Math.min(
        this.game.defaultDimensions.width,
        this.game.defaultDimensions.height * windowAspect
      );
      this._configureViewport(width, height);
    } else super.updateViewport();
  }
}
